// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const MyPlansPageLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-myplanspage" */ "./MyPlansPage")).then((bundle)=>{
        return {
            default: bundle.MyPlansPage
        };
    });
export const LazyMyPlansPage = /*#__PURE__*/ lazy(MyPlansPageLazyLoader);
